import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { WatchlistProvider } from "./contexts/watchlist.context";
import { TVShowIDProvider } from "./contexts/tvShow-id.context";

import "./index.css";

import reportWebVitals from "./reportWebVitals";
import { TVSeasonIDProvider } from "./contexts/tvShow-seasonID.context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TVSeasonIDProvider>
        <TVShowIDProvider>
          <WatchlistProvider>
            <App />
          </WatchlistProvider>
        </TVShowIDProvider>
      </TVSeasonIDProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
